// extracted by mini-css-extract-plugin
export default {"colorpass":"#62c6c4","colorfail":"#e90029"};